/** ZPIN fields from solutions-dashboard-service `GET /zpins` (`ZpinData`). */
export type Zpin = {
  zpin_id: string;
  user_id: string;
  status?: string;
  is_active?: boolean;
  is_deleted?: boolean;
  created_at?: number;
  updated_at?: number;
};

export type ZpinFlowError = {
  text: string;
  isOtpError: boolean;
};

/** Maps API copy onto messages that match what the user can do next. */
export function zpinFlowError(message?: string): ZpinFlowError {
  const raw = String(message || "").trim();
  const lower = raw.toLowerCase();

  if (
    lower.includes("invalid otp") ||
    lower.includes("otp is required") ||
    lower.includes("relay id")
  ) {
    return {
      text: "The OTP is invalid or has expired. Request a new OTP and try again.",
      isOtpError: true,
    };
  }

  if (
    lower.includes("only the current active zpin") ||
    lower.includes("no longer active") ||
    lower.includes("expired zpin cannot")
  ) {
    return {
      text: "This ZPIN is no longer active. Create a new ZPIN to continue. You can reuse a previous 4-digit PIN.",
      isOtpError: false,
    };
  }

  if (lower.includes("exactly 4")) {
    return { text: "ZPIN must be exactly 4 digits.", isOtpError: false };
  }

  if (lower.includes("zpin not found")) {
    return {
      text: "No active ZPIN was found. Create a new ZPIN to continue.",
      isOtpError: false,
    };
  }

  return {
    text: raw || "Unable to save ZPIN. Please try again.",
    isOtpError: false,
  };
}
